import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useGlobalContext } from '../../stores/global';
import MultipleFileLoader from '../MultipleFileLoader/MultipleFileLoader';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: any;
}

export default function Form6(props: Props) {
  const { user } = useGlobalContext();
  const { handleSubmit, setValue, register } = useForm({
    defaultValues: {
      attaches: props.defaultValues?.attaches,
    },
  });

  useEffect(() => {
    register('attaches');
  }, []);

  const handleFilesChange = (files: any[]) => {
    setValue('attaches', files);
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Cargar Imágenes</h1>

      <MultipleFileLoader
        onChange={handleFilesChange}
        defaultFiles={props.defaultValues.attaches}
        type="images"
      />

      {!user?.plan?.reference && (
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <a
            href="/plans#other-services"
            target="_blank"
            style={{ textDecoration: 'none' }}
          >
            Compra aquí Fotografía Inmobiliaria Especializada
          </a>
        </div>
      )}

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
